import { object, string, date, array, number } from "yup";

import { getDateUTCAtMidnight } from "../../../services/date";

const planSchema = (localization) => object({
  title: string().required(localization.plan.fields.title.errors.required),
  start_date: date().required(localization.timeframe.fields.start_date.errors.required),
  target_date: date()
    .required(localization.timeframe.fields.target_date.errors.required)
    .test(
      "is-after-start-date",
      localization.timeframe.fields.target_date.errors.is_after_start_date,
      (target_date, context) => {
        const { start_date } = context.parent;
        return target_date && start_date && target_date > start_date;
      }
    ),
  objectives: array().of(
    object({
      index: number().required(localization.objectives_tasks.index.errors.required),
      title: string().required(localization.objectives_tasks.fields.title.errors.required),
      tasks: array().of(
        object({
          index: number().required(localization.objectives_tasks.tasks.index.errors.required),
          content: string().required(localization.objectives_tasks.tasks.fields.content.errors.required),
          target_date: date()
            .required(localization.objectives_tasks.tasks.fields.target_date.errors.required)
            .test(
              "is-target-date-valid",
              localization.objectives_tasks.tasks.fields.target_date.errors.is_target_date_valid,
              (target_date, context) => {
                const plan = context.from[2].value;
                const start_date = new Date(plan?.start_date);
                const end_date = new Date(plan?.target_date);
                const date = getDateUTCAtMidnight(target_date);

                if (date && start_date && end_date) {
                  return date >= start_date && date <= end_date;
                }

                return false;
              }
            )
        })
      ).required(localization.objectives_tasks.tasks.errors.required)
       .min(1, localization.objectives_tasks.tasks.errors.required)
    })
  ).required(localization.objectives_tasks.errors.required)
   .min(1, localization.objectives_tasks.errors.required),
  time: string()
    .required(localization.time_with_vicky.fields.time.errors.required)
    .matches(/^(?:[01]\d|2[0-3]):[0-5]\d$/, localization.time_with_vicky.fields.time.errors.format),
  frequency: number()
    .required(localization.time_with_vicky.fields.frequency.errors.required)
    .positive(localization.time_with_vicky.fields.frequency.errors.positive)
    .integer(localization.time_with_vicky.fields.frequency.errors.integer),
  periodicity: string().required(localization.time_with_vicky.fields.periodicity.errors.required),
  repeat: array().of(string()),
  ending: object({
    type: string().required(localization.time_with_vicky.fields.ending.errors.type.required),
    on: date().when("type", {
      is: type => type === "on",
      then: field => field
        .required(localization.time_with_vicky.fields.ending.errors.ending_on.required)
        .test(
          "is-ending-on-valid",
          localization.time_with_vicky.fields.ending.errors.ending_on.is_ending_on_valid,
          (ending_on, context) => {
            const plan = context.from[1].value;
            const start_date = new Date(plan?.start_date);
            const end_date = new Date(plan?.target_date);
            const date = getDateUTCAtMidnight(ending_on);
            
            return date >= start_date && date <= end_date;
          }
        ),
      otherwise: field => field.notRequired(),
    }),
    after: number().when("type", {
      is: type => type === "after",
      then: field => field
        .required(localization.time_with_vicky.fields.ending.errors.ending_after.required)
        .positive(localization.time_with_vicky.fields.ending.errors.ending_after.positive)
        .integer(localization.time_with_vicky.fields.ending.errors.ending_after.integer),
      otherwise: field => field.notRequired(),
    }),
  }).required()
}).required();

export default planSchema;